/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect,useState, useCallback } from "react";
import "./jiraCards.css";
import {  FaUserCircle } from "react-icons/fa";
import useApiJira from "../api/administracion/useApiJira";
import FieldDropDown from '../shared/controls/fieldDropDown';
import FieldTextBox from "../shared/controls/fieldTextBox";
const JiraCards = ({ name,esSeccionAutorizar,soloLectura,data }) => {  
   const [issues, setIssues] = useState([]);
   const [sprints, setSprints] = useState([]);
   const  apiJira =useApiJira();
   const [sprintsAbiertos, setSprintsAbiertos] = useState({});
   const [, setLoading] = useState(false);
   const [filtroUsuario, setFiltroUsuario] = useState("");
   const [filtro, setFiltro] = useState("");
   const [epics, setEpics] = useState([]);
   const [epicId, setEpicId] = useState(null);
    useEffect(() => {
        const fetchObtenerEpics = async () => {
            try {
                
                    const dataEpicRaw = await apiJira.obtenerEpics();
                    const dataEpic =
                        typeof dataEpicRaw === "string"
                            ? JSON.parse(dataEpicRaw)
                            : dataEpicRaw;

                    const listaEpics = dataEpic.values.map(epic => ({
                        id: epic.key,
                        nombre: epic.name
                    }));

                    setEpics(listaEpics);
            } catch (error) {
                console.error("Error al cargar epics:", error);
            }
        };

        fetchObtenerEpics();
    }, []);

   const ordenColumnas  = [
        {
            titulo: "Tareas por hacer",
            jiraStatus: "Tareas por hacer"
        },
        {
            titulo: "En curso",
            jiraStatus: "Sesión Entendimiento"
        },
        {
            titulo: "Pruebas",
            jiraStatus: "PO Acceptance"
        },
        {
            titulo: "Publicada",
            jiraStatus: "Finalizada"
        }
    ];
     const cargarIssues = useCallback(async () => {
    setLoading(true);

    try {
        let response;

        if (name === "Tickets") {
            response = await apiJira.obtener();
        } else {
            response = await apiJira.obtenerFuture();
        }

        let data = response;

        if (typeof data === "string") {
            data = JSON.parse(data);
        }

        if (name === "Tickets") {           
            setIssues(data?.issues ?? []);
            setSprints([]);
        } else {
            const listaSprints = Array.isArray(data)
                ? data
                : data?.sprints ?? [];

            setSprints(listaSprints);

            const backlogIssues = listaSprints.flatMap(sprint => sprint.issues ?? []);
            setIssues(backlogIssues);
        }
    }
    catch (error) {
        console.error("Error al cargar Jira:", error);
        setIssues([]);
        setSprints([]);
    }
    finally {
        setLoading(false);
    }
}, [name]);
    useEffect(() => {
    cargarIssues();

    const interval = setInterval(() => {
        cargarIssues();
    }, 5 * 60 * 1000);

    return () => clearInterval(interval);
}, [cargarIssues]);

const toggleSprint = (idSprint) => {
    setSprintsAbiertos(prev => ({
        ...prev,
        [idSprint]: !(prev[idSprint] ?? true)
    }));
};
const groupedIssues = issues.reduce((acc, issue) => {
    const status = issue.fields?.status?.name || "Sin estatus";

    if (!acc[status]) {
        acc[status] = [];
    }

    acc[status].push(issue);

    return acc;
}, {});
const getEpicColor = (epic) => {
    const key =
        epic?.color?.key ||
        epic?.issueColor?.key ||
        epic?.fields?.color?.key ||
        epic?.fields?.issueColor?.key;

    switch (key) {
        case "color_1":
            return "#999999"; // Mejoras Finanzas
        case "color_2":
            return "#E35336"; // Mejoras Seguridad
        case "color_3":
            return "#BA8E23"; // Reportes BI
        case "color_4":
            return "#00B8D9"; // Mejoras TI
        case "color_8":
            return "#8E44AD"; // Soporte General / Operaciones
        case "color_9":
            return "#6554C0"; // Almacén / Analistas
        case "color_10":
            return "#4C9AFF"; // Finanzas-Liquidaciones
        case "color_11":
            return "#00A3BF"; // Mejoras Diesel / RH
        case "color_12":
            return "#97A0AF"; // Mejoras Mantenimiento
        case "color_13":
            return "#00875A"; // Mejoras Comercial
        case "color_14":
            return "#ED2100"; // Bugs

        case "purple":
            return "#8E44AD";
        case "blue":
            return "#0052CC";
        case "green":
            return "#00875A";
        case "red":
            return "#DE350B";
        case "yellow":
            return "#FFAB00";
        case "orange":
            return "#FF991F";

        default:
            return "#6554C0";
    }
};
const formatearFechaSprint = (fecha) => {
    if (!fecha) return "";
    return new Date(fecha).toLocaleDateString("es-MX", {
        day: "numeric",
        month: "short"
    }).replace(".", "");
};

return name === "Tickets" ? (
    <>
        <div className="jira-filtros">
            <div className="jira-filtro-buscar" style={{ marginTop: "27px" }}>
                <FieldTextBox
                    label=""
                    name="filtro"              
                    placeholder="Buscar en tablero"
                    value={filtro}
                    colMd={12}
                  onChange={(value) => {
                        setFiltro(value);
                    }}
                />
            </div>
                        
            <div className="jira-filtro-empleado">
             <FieldDropDown
                    name="epicId"
                    label="Área"
                    options={epics}
                    optionLabel="nombre"
                    optionValue="id"
                    value={epicId}
                    placeholder="Epic"
                    colMd={12}
                    filter={true}
                    showClear={true}
                   onChange={(e) => setEpicId(e?.nombre ?? e?.nombre ?? null)}
                />
            </div>

           <div className="jira-filtro-avatares-container">
                <p className="jira-filtro-titulo-desarrollador">Developer</p>

                <div className="jira-filtro-avatares">
                    <button
                        className="jira-avatar-user bg-cyan"
                        title="Cynthia Macias"
                        onClick={() => setFiltroUsuario("Cynthia Macias")}
                    >
                        CM
                    </button>

                    <button
                        className="jira-avatar-user bg-blue"
                        title="Jesús García Morquecho"
                        onClick={() => setFiltroUsuario("Jesús Eduardo García Morquecho")}
                    >
                        JM
                    </button>

                    <button
                        className="jira-avatar-user bg-orange"
                        title="Romeo Martinez"
                        onClick={() => setFiltroUsuario("Romeo Martinez")}
                    >
                        RM
                    </button>

                    <button
                        className="jira-user-icon-btn"
                        title="Todos"
                        onClick={() => {
                            setFiltroUsuario("");
                            setFiltro("");
                            setEpicId(null);
                        }}
                    >
                        <FaUserCircle className="jira-user-icon" />
                    </button>
                </div>
            </div>
        </div>

        <div className="jira-board">
            {ordenColumnas.map((columna) => {
                const items = groupedIssues[columna.jiraStatus] ?? [];

                const itemsFiltrados = items.filter((issue) => {
                    const textoFiltro = filtro.trim().toLowerCase();
                    const usuario = issue?.fields?.assignee?.displayName ?? "";
                      const epicNombre =
                    issue?.fields?.epic?.name ||
                    issue?.fields?.parent?.fields?.summary ||
                    issue?.fields?.parent?.summary ||
                    "";
                    const coincideTexto =
                        !textoFiltro ||
                        issue?.key?.toLowerCase().includes(textoFiltro) ||
                        issue?.fields?.summary?.toLowerCase().includes(textoFiltro);

                    const coincideUsuario =
                        !filtroUsuario || usuario === filtroUsuario;
                   const coincideEpic =
                    !epicId || epicNombre === epicId;
                    return coincideTexto && coincideUsuario && coincideEpic;
                    });

                return (
                    <div className="jira-column" key={columna.titulo}>
                        <div className="jira-column-header">
                            <span>{columna.titulo.toUpperCase()}</span>
                            <small>{itemsFiltrados.length}</small>
                        </div>

                        {itemsFiltrados.map((issue) => {
                            const fields = issue.fields ?? {};
                            const assignee = fields.assignee;
                            const epic = fields.epic || fields.parent;
                            const points = fields.customfield_10014;

                            return (
                                <div className="jira-card-small" key={issue.id}>
                                    <div className="jira-card-title">{fields.summary}</div>

                                    {epic && (
                                        <div className="jira-tag" style={{ background: getEpicColor(epic) }}>
                                            {epic.name || epic.summary || epic.fields?.summary}
                                        </div>
                                    )}

                                    <div className="jira-card-footer">
                                        <span className="jira-issue-key">
                                            <span className="jira-type-icon">▣</span> {issue.key}
                                        </span>

                                        <div className="jira-card-actions">
                                            {points !== null && points !== undefined && (
                                                <span className="jira-points-small">{points}</span>
                                            )}

                                            <span className="jira-menu">=</span>

                                            {assignee && (
                                                <img
                                                    className="jira-avatar"
                                                    src={assignee.avatarUrls?.["24x24"]}
                                                    alt={assignee.displayName}
                                                    title={assignee.displayName}
                                                />
                                            )}
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                );
            })}
        </div>
    </>
) : (
    <>

        <div className="jira-filtros">
            <div className="jira-filtro-buscar" style={{ marginTop: "27px" }}>
                <FieldTextBox
                    name="filtro"
                    label=""
                    placeholder="Buscar en tablero"
                    value={filtro}
                    colMd={12}
                    onChange={(value) => {                       
                        setFiltro(value);
                    }}
                />
            </div>

            <div className="jira-filtro-empleado">
              {/* <FieldDropDown
                name="epicId"
                options={epics}
                optionLabel="nombre"
                value={epicId}
                placeholder="Epic"
                colMd={12}
                filter={true}
                 onChange={(e) => setEpicId(e?.nombre ?? e?.nombre ?? null)}
            /> */}
            <FieldDropDown
                name="epicId"
                options={epics}
                optionLabel="nombre"
                label="Área"
                optionValue="id"
                value={epicId}
                placeholder="Epic"
                colMd={12}
                filter={true}
                showClear={true}
                onChange={(e) => setEpicId(e?.nombre ?? e?.nombre ?? null)}
            />
            </div>

            <button className="jira-avatar-user bg-cyan" onClick={() => setFiltroUsuario("Cynthia Macias")}>CM</button>
            <button className="jira-avatar-user bg-blue" onClick={() => setFiltroUsuario("Jesús Eduardo García Morquecho")}>JM</button>
            <button className="jira-avatar-user bg-orange" onClick={() => setFiltroUsuario("Romeo Martinez")}>RM</button>

            <button className="jira-user-icon-btn" onClick={() => { setFiltroUsuario(""); setFiltro(""); }}>
                <FaUserCircle className="jira-user-icon" />
            </button>
        </div>

        <div className="jira-list-board">
            {sprints.map((sprint) => {
                const idSprint = sprint.sprintId ?? sprint.id ?? sprint.nombre;
                const abierto = sprintsAbiertos[idSprint] ?? true;

                const issuesFiltrados = (sprint.issues ?? []).filter((issue) => {
                    const textoFiltro = filtro.trim().toLowerCase();
                    const usuario = issue?.fields?.assignee?.displayName ?? "";
                    const epicNombre =
                    issue?.fields?.epic?.name ||
                    issue?.fields?.parent?.fields?.summary ||
                    issue?.fields?.parent?.summary ||
                    "";

                    const coincideTexto =
                        !textoFiltro ||
                        issue?.key?.toLowerCase().includes(textoFiltro) ||
                        issue?.fields?.summary?.toLowerCase().includes(textoFiltro);

                    const coincideUsuario =
                        !filtroUsuario || usuario === filtroUsuario;
                    const coincideEpic =
                    !epicId || epicNombre === epicId;
                    return coincideTexto && coincideUsuario  && coincideEpic;;
                });

                return (
                    <div key={idSprint}>
                        <div
                            className="jira-sprint-header"
                            onClick={() => toggleSprint(idSprint)}
                            style={{ cursor: "pointer" }}
                        >
                            <div className="jira-sprint-left">
                                <span className="jira-chevron">{abierto ? "⌄" : "›"}</span>
                                <strong>{sprint.nombre}</strong>
                                <span>{formatearFechaSprint(sprint.fechaInicio)} – {formatearFechaSprint(sprint.fechaFin)}</span>
                                <span>({issuesFiltrados.length} de {sprint.totalIssues ?? 0} actividades visible)</span>
                            </div>
                        </div>

                        {abierto && (
                            <div className="jira-list">
                                {issuesFiltrados.map((issue) => {
                                    const fields = issue.fields ?? {};
                                    const epic = fields.epic || fields.parent?.fields;
                                    const assignee = fields.assignee;
                                    const points = fields.customfield_10014;

                                    return (
                                        <div className="jira-list-row" key={issue.id}>
                                            <div className="jira-list-main">
                                                <span className="jira-type-icon">▣</span>
                                                <span className="jira-list-key">{issue.key}</span>
                                                <span className="jira-list-title">{fields.summary}</span>
                                            </div>

                                            <div className="jira-list-right">
                                                {epic && (
                                                    <span
                                                        className="jira-list-epic"
                                                        style={{ background: getEpicColor(epic) }}
                                                    >
                                                        {epic.name || epic.summary}
                                                    </span>
                                                )}

                                                <span className="jira-list-status">
                                                    {fields.status?.name?.toUpperCase()}
                                                </span>

                                                {points !== null && points !== undefined && (
                                                    <span className="jira-list-points">{points}</span>
                                                )}

                                                {assignee && (
                                                    <img
                                                        className="jira-avatar"
                                                        src={assignee.avatarUrls?.["24x24"]}
                                                        alt={assignee.displayName}
                                                        title={assignee.displayName}
                                                    />
                                                )}
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                        )}
                    </div>
                );
            })}
        </div>
    </>
);
}
  

export default JiraCards;